import type { TeamListItem } from "../types/teams.types";

export const areAllUsersInTeam = (team: TeamListItem, userIds: readonly number[]): boolean => {
    if (userIds.length === 0) {
        return false;
    }

    const teamMemberIds = new Set(team.users.map((user) => user.userId));
    return userIds.every((userId) => teamMemberIds.has(userId));
};
